import { popupWindow } from '.';
import { routes } from '../lib/routes';

interface OpenAccountLinkingParams {
    url: string;
    onSuccess: () => void;
    onFailure: () => void;
}

const getOrigin = (url: string) => {
    let origin = window.location.origin;
    try {
        origin = new URL(url).origin;
    } catch (_error) {
        console.error('No origin for ', url);
    }
    return origin;
};

const WHITE_LIST_ALLOWED_ORIGINS = [
    window.location.origin,
    getOrigin(__appConfig.app.storeUrl),
    getOrigin(__appConfig.app.webLinkingUrl),
];

export const openAccountLinkingWindow = ({ url, onSuccess, onFailure }: OpenAccountLinkingParams) => {
    url += `&retpath=${window.location.origin}${routes.app.root}/account-linking/redirect/`;

    const wnd = popupWindow(url, 'Авторизация', 350, 500);
    if (wnd) {
        wnd.focus();

        const onMessage = (e: MessageEvent) => {
            if (!WHITE_LIST_ALLOWED_ORIGINS.includes(e.origin)) {
                console.warn('Blocked message from ', e.origin);
                return;
            }
            if (wnd && wnd.closed) {
                window.removeEventListener('message', onMessage);
                return;
            }

            if (!('status' in e.data)) {
                return;
            }

            if (e.data.status === 'ok') {
                onSuccess();
            } else {
                onFailure();
            }

            wnd.close();
            window.removeEventListener('message', onMessage);
        };

        window.addEventListener('message', onMessage);
    }
};
